<ng-template #modalTemplate>
  <div
    *transloco="let t; prefix: 'shared.autocomplete.search-property'"
    class="flex flex-col"
  >
    <div
      class="max-w-[480px] bg-gray-50 flex flex-col justify-between w-full h-full md:!max-w-[808px] z-50 py-4 bg-gray-50 fixed right-0"
    >
      <div class="h-full overflow-y-auto px-4 flex flex-col">
        <div class="flex-1">
          <div
            class="flex md:flex-row flex-row-reverse items-center gap-5 justify-between md:justify-normal mb-5"
          >
            <button
              role="button"
              class="cursor-pointer md:rounded-full w-14 h-14 text-primary-800 md:bg-gray-100"
              (click)="closeMobileModal()"
            >
              <i class="icon-close"></i>
            </button>
            <h4 class="text-black text-xl">{{ t("header") }}</h4>
          </div>
          <fieldset class="flex-1 flex flex-col gap-2 group/input">
            <div
              class="flex items-center text-gray-500 rounded-full bg-white py-1 px-1 transition-colors duration-300 outline-none w-full min-w-[200px]"
              [ngClass]="
                isHomepage
                  ? ''
                  : 'h-[54px] border border-gray-300 group-hover/input:bg-white group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500'
              "
            >
              <span
                *ngIf="!isHomepage"
                class="flex justify-center items-center mr-2 ml-3"
              >
                <i
                  *ngIf="showSearchIcon"
                  class="icon-search text-gray-700 text-xl"
                ></i>
              </span>
              <div class="flex flex-row flex-1 items-center">
                <input
                  (click)="showDropDown()"
                  (clickOutside)="hideDropdown()"
                  class="outline-none flex-1 group-hover/input:bg-white transition-colors duration-300 mr-2 w-full"
                  [ngClass]="{ 'text-black': isHomepage }"
                  [placeholder]="
                    searchPlaceholder
                      ? searchPlaceholder
                      : t('search-placeholder')
                  "
                  (keyup)="onInputKeyUp($event)"
                  #searchInput
                />
                @if (!isHomepage && selectedItems.length > 0) {
                <div class="flex items-center gap-2">
                  <app-search-badge
                    [text]="selectedItems[0].FormatedAddress"
                    (remove)="onItemRemove(selectedItems[0])"
                  >
                  </app-search-badge>
                  @if (selectedItems.length > 1) {
                  <button
                    type="button"
                    class="btn-secondary whitespace-nowrap py-1 px-1 sm:px-3 min-w-[34px] border-white sm:border-[#C2CCD3]"
                    (click)="showBadgeListClicked()"
                  >
                    <span>+{{ selectedItems.length }}</span>
                    <span class="sm:block hidden">more</span>
                  </button>
                  }
                </div>
                }
              </div>
            </div>
          </fieldset>
          @if (showBadgeList) {
          {{ "show" }}
          <div
            class="flex gap-x-4 gap-y-3 absolute left-0 flex-wrap w-full bg-white shadow-[0px_4px_18px_0px_#0000002B]"
          >
            <div
              *ngFor="let selectedItem of selectedItems"
              class="flex items-center justify-between gap-2 text-base text-black font-normal border border-gray-300 px-4 py-2 rounded-lg transition-colors duration-300 outline-none group-hover/input:bg-white group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500"
            >
              <span class="flex-1 truncate text-left">{{
                selectedItem.FormatedAddress
              }}</span>

              <button
                class="w-5 h-5 flex items-center justify-center text-black hover:text-black"
                (click)="onItemRemove(selectedItem)"
              >
                <i class="icon-close"></i>
              </button>
            </div>

            @if(selectedItems.length == 0){
            <div class="min-h-[43px]"></div>
            }
          </div>
          }
          <div class="mt-4 overflow-y-auto">
            <section class="w-full pb-4 px-8">
              <button
                type="button"
                *ngFor="let item of items; let i = index"
                [ngClass]="{ 'text-black': isHomepage }"
                class="group/menu-item [&.error]:bg-error-light [&.error]:hover:bg-error-light [&.error]:focus-within:bg-error-light py-[2px] px-1 [&:not(:disabled,.error)]:focus-within:hover:bg-black/20 [&:not(:disabled,.error)]:focus-within:bg-black/20 [&:not(:disabled,.error)]:hover:bg-black/03 flex items-center justify-start min-w-[280px] w-full"
                (click)="onListItemSelected(item)"
              >
                <ng-container
                  [ngTemplateOutlet]="defaultItemTemplate"
                  [ngTemplateOutletContext]="{ $implicit: item }"
                >
                </ng-container>
              </button>
            </section>
            <section
              class="w-full px-8 py-4"
              [ngClass]="
                historySearches && historySearches.length > 0
                  ? 'visible'
                  : 'hidden'
              "
            >
              <div class="flex items-center my-4 gap-2">
                <i
                  class="group-disabled/menu-item:text-gray-700 icon-clock text-base px-1"
                ></i>
                <span
                  class="font-normal text-base"
                  [ngClass]="
                    isHomepage
                      ? 'font-semibold group-disabled/menu-item:text-gray-50'
                      : 'text-gray-700'
                  "
                  >{{ t("text.recentSearches") }}</span
                >
              </div>
              <button
                *ngFor="let search of historySearches"
                (click)="savedSearchSelected(search)"
                [ngClass]="isHomepage ? 'py-1' : 'py-3'"
                class="group/menu-item [&.error]:bg-error-light [&.error]:hover:bg-error-light [&.error]:focus-within:bg-error-light px-1 [&:not(:disabled,.error)]:focus-within:hover:bg-black/20 [&:not(:disabled,.error)]:focus-within:bg-black/20 [&:not(:disabled,.error)]:hover:bg-black/03 flex items-center justify-between min-w-[280px] w-full"
              >
                <div class="flex items-center text-base text-left font-normal">
                  <span
                    class="bg-transparent group-disabled/menu-item:text-gray-50"
                    >{{ cleanUpEncodedCharacters(search.name ?? "") }}</span
                  >
                </div>
              </button>
            </section>
            @if (propertiesFoundByCode && propertiesFoundByCode.length > 0) {
            <section class="w-full px-4 py-4">
              <h3 class="mb-4">{{ t("properties") }}</h3>
              @for (property of propertiesFoundByCode; track property.id) {
              <app-search-property-item
                [property]="property"
              ></app-search-property-item>
              }
            </section>
            }
            <!-- <div *ngIf="!isHomepage" class="flex-grow border-t border-gray-200 w-full mt-2 mb-2"></div> -->
            <!-- <section *ngIf="popularAreas && popularAreas.length > 0 && !hideUserHistory" class="px-4 py-4">
                            <div class="flex items-center my-4 gap-2">
                                <i class="group-disabled/menu-item:text-gray-700 icon-fire-alt text-base px-1"></i>
                                <span class="font-normal text-base"
                                    [ngClass]="isHomepage ? 'font-semibold group-disabled/menu-item:text-gray-50' : 'text-gray-700'">{{t('text.popularAreas')}}</span>
                            </div>
                            <button *ngFor="let search of popularAreas" (click)="savedSearchSelected(search)"
                                class="py-1 group/menu-item [&.error]:bg-error-light [&.error]:hover:bg-error-light [&.error]:focus-within:bg-error-light px-1 [&:not(:disabled,.error)]:focus-within:hover:bg-black/20 [&:not(:disabled,.error)]:focus-within:bg-black/20 [&:not(:disabled,.error)]:hover:bg-black/03 flex items-center justify-between min-w-[280px] w-full">
                                <div class="flex items-center text-base text-left font-normal">
                                    <span
                                        class="bg-transparent group-disabled/menu-item:text-gray-50">{{cleanUpEncodedCharacters(search.name ??'')}}</span>
                                </div>
                            </button>
                        </section> -->
          </div>
        </div>
        <button
          class="btn-primary self-stretch w-full h-12 py-4 rounded-full justify-center items-center gap-2 inline-flex"
          (click)="search()"
        >
          {{ t("header") }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
<div
  *transloco="let t; prefix: 'shared.autocomplete.search-property'"
  class="flex flex-col"
  [ngClass]="isHomepage ? '' : 'gap-4'"
>
  <div [ngClass]="isHomepage || showBadgeList || !isFullScreenDdl ? 'relative' : ''">
    <fieldset class="flex-1 flex flex-col gap-2 group/input">
      <div
        class="flex items-center text-gray-500 rounded-full bg-white py-1 px-1 transition-colors duration-300 outline-none w-full min-w-[200px]"
        [ngClass]="
          isHomepage
            ? ''
            : 'h-[54px] border border-gray-300 group-hover/input:bg-white group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500'
        "
      >
        <span
          *ngIf="!isHomepage"
          class="flex justify-center items-center mr-2 ml-3"
        >
          <i
            *ngIf="showSearchIcon"
            class="icon-search text-gray-700 text-xl"
          ></i>
        </span>
        <div class="flex flex-row flex-1 items-center">
          <input
            (click)="showDropDown()"
            (clickOutside)="hideDropdown()"
            [attr.disabled]="(disableInput | async) ? 'true' : undefined"
            [value]="selection"
            class="outline-none flex-1 group-hover/input:bg-white transition-colors duration-300 mr-2 w-full"
            [ngClass]="{ 'text-black': isHomepage }"
            [placeholder]="
              searchPlaceholder ? searchPlaceholder : t('search-placeholder')
            "
            (keyup)="onInputKeyUp($event)"
            #searchInput
          />
          @if (!isHomepage && selectedItems.length > 0) {
          <div class="flex items-center gap-2">
            <app-search-badge
              [text]="selectedItems[0].FormatedAddress"
              (remove)="onItemRemove(selectedItems[0])"
            >
            </app-search-badge>
            @if (selectedItems.length > 1) {
            <button
              type="button"
              class="btn-secondary whitespace-nowrap py-1 px-1 sm:px-3 min-w-[34px] border-white sm:border-[#C2CCD3]"
              (click)="showBadgeListClicked()"
            >
              <span>+{{ selectedItems.length - 1 }}</span>
              <span class="sm:block hidden">more</span>
            </button>
            }
          </div>
          }
        </div>
      </div>
    </fieldset>
    @if (showBadgeList) {
    <div
      class="flex flex-wrap bg-white w-full absolute left-0 rounded-xl shadow-2xl gap-y-3 gap-x-4 p-4"
      (clickOutside)="showBadgeList = false"
    >
      <div
        *ngFor="let selectedItem of selectedItems"
        class="py-2 pr-3 pl-4 rounded-full bg-gray-50 flex items-center justify-between gap-2"
      >
        <span
          class="flex-1 truncate text-left font-sm text-black font-semibold"
          >{{ selectedItem.FormatedAddress }}</span
        >

        <button
          class="w-5 h-5 flex items-center justify-center text-gray-700 hover:text-black"
          (click)="onItemRemove(selectedItem)"
        >
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
    }
    <div
      *ngIf="
        showResults &&
        ((historySearches && historySearches.length > 0) ||
          items ||
          propertiesFoundByCode)
      "
      class="z-[60]"
      [ngClass]="
        !isFullScreenDdl ?
        isHomepage
          ? 'bg-white text-base md:translate-y-8 md:-left-10 md:w-[350px] md:absolute md:top-[100%] md:rounded-xl md:px-4 md:py-4 md:shadow-2xl'
          : 'bg-white px-4 sm:px-8 lg:px-[3rem] xl:px-[4.5rem] translate-y-full py-6 w-full absolute left-0 right-0 bottom-0
          shadow-2xl'
          : 'bg-white px-4 sm:px-8 lg:px-[3rem] xl:px-[4.5rem] translate-y-full py-6 w-screen absolute left-0 right-0 bottom-0 -translate-x-[2rem] lg:-translate-x-[3.5rem] xl:-translate-x-[4.5rem] shadow-2xl'
      "
    >
      <div [ngClass]="!isHomepage ? 'grid grid-cols-2' : ''">
        <div>
          @if (items) {
          <section class="w-full">
            <button
              type="button"
              *ngFor="let item of items; let i = index"
              [ngClass]="{ 'text-black': isHomepage }"
              class="group/menu-item [&.error]:bg-error-light [&.error]:hover:bg-error-light [&.error]:focus-within:bg-error-light py-[6px] px-2 [&:not(:disabled,.error)]:focus-within:hover:bg-gray-50 [&:not(:disabled,.error)]:focus-within:bg-black/20 [&:not(:disabled,.error)]:hover:bg-black/03 flex items-center justify-start min-w-[280px] w-full"
              (click)="onListItemSelected(item)"
            >
              <ng-container
                [ngTemplateOutlet]="defaultItemTemplate"
                [ngTemplateOutletContext]="{ $implicit: item }"
              >
              </ng-container>
            </button>
          </section>
          }
          <section
            *ngIf="historySearches && historySearches.length > 0"
            class="w-full px-4 py-4"
          >
            <h3 class="mb-3">{{ t("text.recentSearches") }}</h3>
            <button
              *ngFor="let search of historySearches"
              (click)="savedSearchSelected(search)"
              [ngClass]="isHomepage ? 'py-1' : 'py-3'"
              class="group/menu-item [&.error]:bg-error-light [&.error]:hover:bg-error-light [&.error]:focus-within:bg-error-light py-[6px] px-2 [&:not(:disabled,.error)]:focus-within:hover:bg-gray-50 [&:not(:disabled,.error)]:focus-within:bg-black/20 [&:not(:disabled,.error)]:hover:bg-black/03 flex items-center justify-start min-w-[280px] w-full"
            >
              <div class="flex items-center text-base text-left font-normal">
                <span
                  class="bg-transparent group-disabled/menu-item:text-gray-50"
                >
                  {{ cleanUpEncodedCharacters(search.name ?? "") }}</span
                >
              </div>
            </button>
          </section>
          @if (propertiesFoundByCode && propertiesFoundByCode.length > 0) {
          <section class="w-full px-8 py-4">
            <h3 class="mb-4">{{ t("properties") }}</h3>
            @for (property of propertiesFoundByCode; track property.id) {
            <app-search-property-item
              [property]="property"
            ></app-search-property-item>
            }
          </section>
          }
        </div>
        @if (!isHomepage) {
        <section>
          <h3 class="mb-3">{{ t("text.chosen-locations") }}</h3>
          <div class="flex flex-wrap gap-y-3 gap-x-4">
            <div
              *ngFor="let selectedItem of selectedItems"
              class="py-2 pr-3 pl-4 rounded-full bg-gray-50 flex items-center justify-between gap-2 max-h-[32px]"
            >
              <span
                class="flex-1 truncate text-left font-sm text-black font-semibold"
                >{{ selectedItem.FormatedAddress }}</span
              >

              <button
                class="w-5 h-5 flex items-center justify-center text-gray-700 hover:text-black"
                (click)="onItemRemove(selectedItem)"
              >
                <i class="icon-close"></i>
              </button>
            </div>
          </div>
        </section>
        }
      </div>
    </div>
  </div>
</div>
<ng-template #defaultNoResultsTemplate let-searchTerm>
  <div
    class="flex items-center"
    *transloco="let t; prefix: 'shared.autocomplete.search-property'"
  >
    <span class="bg-transparent group-disabled/menu-item:text-tone-06"
      >{{ t("text.noResultsFoundFor") }} <i>{{ searchTerm }}</i>
    </span>
  </div>
</ng-template>
<ng-template #defaultItemTemplate let-item>
  <div class="flex items-center justify-start text-left">
    <span
      class="bg-transparent group-disabled/menu-item:text-tone-06 group-hover/menu-item:text-primary-700"
      >{{ item.description }}</span
    >
  </div>
</ng-template>
